module.exports = __webpack_public_path__ + "static/media/no-academies.515a4c12.svg";